<template>

  <div class="vflex">
    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('Stages') }}</h4>
        </div>
        <div class="btn-row">
            <button
              type="button"
              class="btn btn-primary"
              @click="showCreateModal()">
              + {{ $t('New') }}
              </button>
        </div>
      </div>
    </div>

    <div class="vflex-row-1">
      
      <table
        class="table"
        :class="{'box-loading': loading}">
        <thead>
          <tr>
            <th class="text-truncate"></th>
            <th class="text-truncate">{{ $t('Name') }}</th>
            <th class="text-truncate">{{ $t('Type') }}</th>
            <th class="text-truncate">{{ $t('Default') }}</th>
            <th class="text-truncate">{{ $t('Active') }}</th>
            <th class="text-truncate">{{ $t('Actions') }}</th>
          </tr>
        </thead>
        <tbody v-sortable="{handle: '.sortable-move', items: stages, onUpdate: onSortUpdate}">
          <StageItem
            v-for="(stage, index) in stages"
            :key="index"
            :stage="stage"
            @refresh="loadData" />
        </tbody>
      </table>

      <StageForm
        v-if="modal_select"
        :initStage="modal_select" 
        @hideModal="hideModal()" 
        @deleted="loadData(); hideModal()" 
        @saved="loadData(); hideModal()" />
    </div>

  </div>

</template>

<script>
import StageForm from './StageForm'
import StageItem from './StageItem'

export default {
  name: 'Stage',
  components: {
    StageForm,
    StageItem
  },
  data () {
    return {
      creating: true,
      loading: true,
      modal_select: false
    }
  },
  created () {
    this.loadData()
  },
  computed: {
    stages () {
      return this.$store.getters.getStages
    },
    stageTypes () {
      return {
        'applied': this.$t('Application'),
        'sourced': 'Triagem',
        'phone-screen': 'Contato por telefone',
        'shortlist': 'Shortlist',
        'interview': 'Entrevista',
        'offer': 'Oferta',
        'hired': 'Contratado'
      }
    }
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.loading = true

      this.$store
      .dispatch('selectStages', {
        limit: 1000
      })
      .then((response) => {
        this.loading = this.creating = false
      })
    },
    /*
    modal
    */
    showCreateModal () {
      this.modal_select = {}
    },
    hideModal () {
      this.modal_select = false
    },
    onSortUpdate (stages) {
      this.$store.commit('SET_STAGES_SELECT_IDS', stages.map((v) => {
        return v._id
      }))

      stages.forEach((stage, key) => {
        this.$store.dispatch('updateStage', {_id: stage._id, position: key})
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Stage/Stage.vue